<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<child-onboarding-container
  [formValid]="isFormValid$ | async"
  (forward)="submit()"
  (back)="back()"
  [buttonLabel]="store.childOnboardingToAccept() ? 'child-onboarding.legal-guardian-2-confirmation.btn-accept' : undefined"
>
  <p class="zero-text p-huge-med">{{ 'child-onboarding.legal-guardian-2-confirmation.headline' | transloco }}</p>
  @if (store.childOnboardingToAccept(); as childOnboardingToAccept) {
    <ul>
      <li class="zero-text p-base-reg">
        {{
          'child-onboarding.legal-guardian-2-confirmation.child'
            | transloco
              : {
                  firstName: childOnboardingToAccept.vorname,
                  lastName: childOnboardingToAccept.nachname,
                  birthDate: childOnboardingToAccept.geburtsdatum | date,
                }
        }}
      </li>
      <li class="zero-text p-base-reg">
        {{
          'child-onboarding.legal-guardian-2-confirmation.applicant'
            | transloco
              : {
                  name: childOnboardingToAccept.legalGuardian1FullName,
                }
        }}
      </li>
      <li class="zero-text p-base-reg">
        {{
          'child-onboarding.legal-guardian-2-confirmation.hint'
            | transloco
              : {
                  name: childOnboardingToAccept.legalGuardian1FullName,
                }
        }}
      </li>
      <li class="zero-text p-base-reg">
        {{
          'child-onboarding.legal-guardian-2-confirmation.phone'
            | transloco
              : {
                  phone: childOnboardingToAccept.mobileNumber,
                }
        }}
      </li>
      <li class="zero-text p-base-reg">
        {{
          'child-onboarding.legal-guardian-2-confirmation.iban'
            | transloco
              : {
                  iban: childOnboardingToAccept.iban,
                }
        }}
      </li>
    </ul>
    <hr />
    <child-onboarding-docs [onboardingId]="store.childOnboardingToAccept()?.onboardingId" />
    <hr />
    <div class="mt-3">
      <web-components-trading-session (authorizationState)="setSessionAuthState($event)" />
    </div>
    <p class="zero-text p-base-med mb-0 mt-2">
      {{ 'child-onboarding.legal-guardian-2-confirmation.acceptance' | transloco }}
    </p>
  } @else {
    <p class="zero-text p-base-reg">
      {{ 'child-onboarding.legal-guardian-2-confirmation.text' | transloco }}
    </p>
    <p class="zero-text p-base-reg mt-2">
      {{ 'child-onboarding.legal-guardian-2-confirmation.description' | transloco: { name: selectedChildOnboarding()?.vorname } }}
    </p>
    <div class="d-flex gap justify-content-between">
      <web-design-system-input
        type="number"
        labelSize="small"
        [value]="birthDay$ | async"
        [isValid]="birthDay$ | async | underageDay: (birthMonth$ | async) : (birthYear$ | async)"
        [label]="'child-onboarding.legal-guardian-2-confirmation.birthDay' | transloco"
        (valueChange)="handleBirthDayChange($event)"
      />
      <web-design-system-input
        type="number"
        labelSize="small"
        [value]="birthMonth$ | async"
        [isValid]="birthMonth$ | async | underageMonth: (birthDay$ | async) : (birthYear$ | async)"
        [label]="'child-onboarding.legal-guardian-2-confirmation.birthMonth' | transloco"
        [focus]="(focussedField$ | async) === 'birthMonth'"
        (valueChange)="handleBirthMonthChange($event)"
      />
      <web-design-system-input
        type="number"
        labelSize="small"
        [value]="birthYear$ | async"
        [isValid]="birthYear$ | async | underageYear: (birthDay$ | async) : (birthMonth$ | async)"
        [label]="'child-onboarding.legal-guardian-2-confirmation.birthYear' | transloco"
        [focus]="(focussedField$ | async) === 'birthYear'"
        (valueChange)="handleBirthYearChange($event)"
      />
    </div>
    @if (birthdateError$ | async; as errorType) {
      <p class="zero-text course-red p-small-reg mt-2">
        {{ 'child-onboarding.legal-guardian-2-confirmation.birth-date-error.invalid' | transloco }}
      </p>
    }
  }
</child-onboarding-container>
